module.exports = [{"0xCBA5018De6b2b6F89d84A1F5A68953f07554765e":"12"},{"0xa6Bf70bd230867c870eF13631D7EFf1AE8Ab85c9":"1123.45645"},{"0x00b5F428905DEA1a67940093fFeaCeee58cA91Ae":"1.049"},{"0x00fC79F38bAf0dE21E1fee5AC4648Bc885c1d774":"14546"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/example.json
// module id = 233
// module chunks = 0